import { DashboardScreen } from './auth/DashboardScreen';
import { SignInScreen } from './auth/SignInScreen';
import { useViewer } from './auth/useViewer';

/**
 * One decision: is anybody signed in?
 *
 * The dashboard is never rendered from a local guess about that. Until the
 * server has answered, neither screen is shown, so a revoked session cannot
 * flash a dashboard before disappearing.
 */
export function App(): React.JSX.Element {
  const { state, signIn, signOut } = useViewer();

  if (state.status === 'checking') {
    return (
      <main className="screen">
        <p className="loading" data-testid="checking">
          Checking your session…
        </p>
      </main>
    );
  }

  if (state.status === 'unreachable') {
    return (
      <main className="screen">
        <div className="auth">
          <header className="auth__head">
            <span className="brand__mark-box" aria-hidden="true">
              SFC
            </span>
            <p className="auth__org">Society for Code</p>
            <h1>Dashboard</h1>
          </header>
          <p className="auth__card notice notice--problem" role="status" data-testid="unreachable-notice">
            The API did not answer. Start the backend, or point <code>VITE_API_BASE_URL</code> at a running one.
          </p>
        </div>
      </main>
    );
  }

  if (state.status === 'signed-in') {
    return <DashboardScreen viewer={state.viewer} onSignOut={signOut} />;
  }

  return <SignInScreen onSignIn={signIn} />;
}
